import { absoluteTime, timeAgo } from "../lib/format";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

/** Relative time ("7h ago") with the actual local time on hover. */
export function TimeAgo({ at, className }: { at: string | null | undefined; className?: string }) {
  const label = timeAgo(at);
  if (!at || label === "—") return <span className={className}>{label}</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time dateTime={at} className={className}>
          {label}
        </time>
      </TooltipTrigger>
      <TooltipContent>{absoluteTime(at)}</TooltipContent>
    </Tooltip>
  );
}
